import { Globe2, Mail, MapPin } from 'lucide-react';

import { CONTACT_EMAIL, OFFICES, REGISTERED_ADDRESS } from '../../content/site';
import { Card, Container, SectionHeading } from '../ui';

export function About() {
  return (
    <section
      aria-labelledby="about-title"
      className="bg-surface py-24 md:py-32"
      id="about"
    >
      <Container className="grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <SectionHeading
            eyebrow="About us"
            id="about-title"
            title="We care how products feel to the people using them"
          />
          <div className="mt-6 max-w-2xl space-y-4 text-report-lede text-text-secondary">
            <p>
              Floto is a team of designers and engineers who obsess over craft
              and feedback: the honest, specific kind that turns a good product
              into one that works for everyone.
            </p>
            <p>
              Accessibility is where that matters most. When a checkout traps a
              keyboard user, or a form goes silent for a screen reader, someone
              is shut out. We help builders find those moments early, understand
              them clearly and fix them with confidence.
            </p>
            <p className="text-text-primary">
              Our mission: give every builder and company the feedback they need
              to make products that truly meet their users’ needs.
            </p>
          </div>
        </div>

        <ul className="space-y-3 lg:col-span-5 lg:pt-16">
          <li>
            <Card className="flex items-start gap-4 p-5">
              <Globe2
                aria-hidden
                className="mt-1 shrink-0 text-brand"
                size={20}
              />
              <div>
                <p className="text-ui-strong font-semibold text-text-primary">
                  Headquartered in the {OFFICES.headquarters}
                </p>
                <p className="mt-1 text-ui text-text-secondary">
                  With teams in {OFFICES.operations.join(' and ')}, working
                  across your time zones.
                </p>
              </div>
            </Card>
          </li>
          {REGISTERED_ADDRESS.length > 0 ? (
            <li>
              <Card className="flex items-start gap-4 p-5">
                <MapPin
                  aria-hidden
                  className="mt-1 shrink-0 text-brand"
                  size={20}
                />
                <div>
                  <p className="text-ui-strong font-semibold text-text-primary">
                    Registered office
                  </p>
                  <address className="mt-1 text-ui not-italic text-text-secondary">
                    {REGISTERED_ADDRESS.map((line) => (
                      <span className="block" key={line}>
                        {line}
                      </span>
                    ))}
                  </address>
                </div>
              </Card>
            </li>
          ) : null}
          <li>
            <Card className="flex items-start gap-4 p-5">
              <Mail
                aria-hidden
                className="mt-1 shrink-0 text-brand"
                size={20}
              />
              <div>
                <p className="text-ui-strong font-semibold text-text-primary">
                  Talk to us
                </p>
                <a
                  className="mt-1 inline-block text-ui text-text-primary underline"
                  href={`mailto:${CONTACT_EMAIL}`}
                >
                  {CONTACT_EMAIL}
                </a>
              </div>
            </Card>
          </li>
        </ul>
      </Container>
    </section>
  );
}
